import { render, staticRenderFns } from "./Classificacao.vue?vue&type=template&id=580a70c4&scoped=true&"
import script from "./Classificacao.vue?vue&type=script&lang=js&"
export * from "./Classificacao.vue?vue&type=script&lang=js&"
import style0 from "./Classificacao.vue?vue&type=style&index=0&id=580a70c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a70c4",
  null
  
)

export default component.exports